import React, {useCallback, useEffect, useRef, useState} from 'react';
import PrismaZoom from 'react-prismazoom';

import {useHttpClient} from '../../../common/hook/http';

import GlobalConst from '../../../common/global-const';

import {useFrom} from '../../../common/hook/form';
import FormElement from '../../../common/component/FormElement/FormElement';

import OffcanvasMap from '../../offcanvas/Map/Map';

import Loader from '../../../common/component/Loader/Loader';

import {Container, Row, Col, Button} from 'react-bootstrap';

import {ReactComponent as ImgMapBg} from '../../../asset/img/map/bg.svg';
import * as IconFi from 'react-icons/fi';

import './Map.scss';

const Map = () => {
    const {callAPI} = useHttpClient()
    const refPrismaZoom = useRef();

    // ------------------------------------------------------------------------------------------------------------ data

    const [data, setData] = useState(null)
    const [floorCurrent, setFloorCurrent] = useState({value: null, svg: null})

    useEffect(() => {

        const fetchData = async () => {
            try {
                const responseData = await callAPI(
                    `parameters/shops`,
                );

                // console.log(responseData)

                if (responseData.message) {

                } else {

                    // بعدا با استفاده از jQuery wayfinding این کدها حذف می شوند
                    responseData['svg'] = await Promise.all(responseData.floors.map(async item => {
                        const svg = await fetch(`${GlobalConst.cdn}maps/floor-${item.value}.svg?${Date.now()}`);
                        // if (svg.status !== 200) return ReactDOMServer.renderToString(<div className="d-flex flex-column align-items-center text-danger"><IconFi.FiAlertTriangle size={48} className="sw-1 mb-3"/><span className="fs-5">اطلاعات نقشه دریافت نشد</span></div>)
                        if (svg.status !== 200) return null
                        return svg.text();
                    }));

                    setData(responseData)

                    // متغیر responseData ارسال شد چون هنوز data بروز نشده است
                    setFloorHandler(responseData.floors.find(({active}) => Number(active)).value, responseData)

                }

            } catch (e) {
                console.error(e);
            }
        }

        fetchData()

    }, [])

    // --------------------------------------------------------------------------------------------------- map offcanvas

    const [offcanvasData, setOffcanvasData] = useState(null);
    const [offcanvasMapShow, setOffcanvasMapShow] = useState(false);

    const offcanvasMapShowHandler = useCallback(item => {

        let shopTemp = null

        if (item.target) {

            // if (item.target.nodeName.toLowerCase() === 'text' || (item.target.nodeName.toLowerCase() === 'path' && item.target.id !== '' && !item.target.classList.contains('active-click') && !item.target.classList.contains('active-search'))) {
            if (item.target.nodeName.toLowerCase() === 'path' && item.target.id !== '' && !item.target.classList.contains('active-click') && !item.target.classList.contains('active-search')) {

                if (document.querySelector('#pageMap #map svg .active-search')) document.querySelector('#pageMap #map svg .active-search').classList.remove('active-search')
                if (document.querySelector('#pageMap #map svg .active-click')) document.querySelector('#pageMap #map svg .active-click').classList.remove('active-click')

                // if (item.target.nodeName.toLowerCase() === 'text') {
                //
                //     item.target.previousElementSibling.classList.add('active-click')
                //     shopTemp = item.target.previousElementSibling.id.replace('path', '')
                //
                // } else {

                item.target.classList.add('active-click')
                shopTemp = item.target.id.replace('path', '')

                // }

            }

        } else {

            if (document.querySelector('#pageMap #map svg .active-search')) document.querySelector('#pageMap #map svg .active-search').classList.remove('active-search')
            if (document.querySelector('#pageMap #map svg .active-click')) document.querySelector('#pageMap #map svg .active-click').classList.remove('active-click')

            // تاخیر برای رندر نفشه طبقه جدید
            let timeout = setTimeout(() => {

                setFloorHandler(data.floors.find(({label}) => label === data.shops.find(({value}) => value === item).floor).value)

                if (document.querySelector(`#pageMap #map svg #path${item}`)) {

                    shopTemp = item
                    document.querySelector(`#pageMap #map svg #path${item}`).classList.add('active-search')

                } else setOffcanvasMapShow(false)

                clearTimeout(timeout)

            }, 0)

        }

        // تاخیر برای مقدار گرفتن shopTemp
        let timeout = setTimeout(() => {

            if (shopTemp) {

                setOffcanvasData(() => {
                    return data.shops.find(({value}) => value === shopTemp)
                })

                // بدون شرط هش offcanvasMap بارها تکرار می شود
                if (!offcanvasMapShow) setOffcanvasMapShow(true);

            }

            clearTimeout(timeout)

        }, .1)

    }, [data])

    const [formMapSearchClear, setFormMapSearchClear] = useState(false)

    const offcanvasMapHideHandler = () => {

        if (document.querySelector('#pageMap #map svg .active-search')) document.querySelector('#pageMap #map svg .active-search').classList.remove('active-search')
        if (document.querySelector('#pageMap #map svg .active-click')) document.querySelector('#pageMap #map svg .active-click').classList.remove('active-click')

        if (document.querySelector('#pageMap #formMapSearch .react-select__clear-indicator')) {
            setFormMapSearchClear(true)
            setFormMapSearchClear(false)
        }

        setOffcanvasMapShow(false)

    }

    // ---------------------------------------------------------------------------------------- floor, search and filter

    const [formState, inputHandler] = useFrom({
        formMapSearch: {
            value: '',
            isValid: true
        },
        formMapFloor: {
            value: '',
            isValid: true
        }
    }, true)

    useEffect(() => {

        if (data && formState.inputs.formMapSearch.value && formState.inputs.formMapSearch.value !== '') offcanvasMapShowHandler(formState.inputs.formMapSearch.value)

    }, [formState.inputs.formMapSearch.value])

    const [filters, setFilters] = useState([
        {id: '1', title: 'خرید کنید', value: 'filter1', active: false},
        {id: '2', title: 'میل کنید', value: 'filter2', active: false},
        {id: '3', title: 'تفریح کنید', value: 'filter3', active: false}
    ])

    const setFilterHandler = filter => {

        let $elements = document.querySelectorAll(`#pageMap #map svg [data-category=${filter}]`)

        for (const item of $elements) item.classList.toggle('active-filter');

        let filtersTemp = [...filters]

        filtersTemp.find(({value}) => value === filter).active = !filtersTemp.find(({value}) => value === filter).active

        setFilters(filtersTemp)

    }

    const handlePathTitle = ($path, item) => {

        let bbox = $path.getBBox();
        let pathCenterX = bbox.x + bbox.width / 2;
        let pathCenterY = bbox.y + bbox.height / 2;

        let $text = document.createElementNS($path.namespaceURI, 'text');

        $text.setAttribute('x', pathCenterX);
        $text.setAttribute('y', pathCenterY);
        $text.setAttribute('text-anchor', 'middle');
        $text.setAttribute('alignment-baseline', 'central');
        $text.setAttribute('dominant-baseline', 'central');
        $text.textContent = item.label;
        $text.setAttribute('transform', `translate(${item.parameters[1] ? item.parameters[1] : 0} ${item.parameters[2] ? item.parameters[2] : 0}) rotate(${item.parameters[3] ? item.parameters[3] : 0} ${pathCenterX} ${pathCenterY})`);

        $path.after($text);

        $text.setAttribute('style', `font-size: ${((bbox.width * 90 / 100) * ((item.parameters[0] ? item.parameters[0] : 100) / 100)) / $text.getBBox().width}em`);

    }

    const handlePathLogo = ($path, item) => {

        let bbox = $path.getBBox();
        let pathCenterX = bbox.x + bbox.width / 2;
        let pathCenterY = bbox.y + bbox.height / 2;

        if (item.parameters[0].includes('\\r\\n'))
            item.parameters = item.parameters[0].split('\\r\\n')
        let imageWidth = (bbox.width * 80 / 100) * (item.parameters[0] / 100);

        let $image = document.createElementNS($path.namespaceURI, 'image');

        $image.setAttribute('href', `${GlobalConst.cdn}${item.logo}`);
        $image.setAttribute('width', imageWidth);
        $image.setAttribute('x', pathCenterX - (imageWidth / 2));
        $image.setAttribute('visibility', 'hidden');

        $image.setAttribute('transform', `translate(${item.parameters[1]} ${item.parameters[2]}) rotate(${item.parameters[3]} ${pathCenterX} ${pathCenterY})`);

        $path.after($image);

        $image.onload = () => {
            let timeout = setTimeout(() => {
                $image.setAttribute('y', pathCenterY - ($image.getBBox().height / 2))
                $image.removeAttribute('visibility')
                clearTimeout(timeout)
            }, 0)
        };

    }

    const setFloorHandler = useCallback ((floor, parameter2) => {

        // زمان تغییر ToggleButtonGroup مقدار event بعنوان parameter2 دریافت می گردد
        let dataTemp = parameter2 && !parameter2.type ? {...parameter2} : {...data}

        setFloorCurrent({value: floor, svg: dataTemp.svg[floor - 1]})

        // ریست کردن فیلتر
        if (filters.find(({active}) => active)) {
            let filtersTemp = [...filters]

            filtersTemp = filtersTemp.map(item => {
                item.active = false;
                return item
            })

            setFilters(filtersTemp)
        }

        // اگر فقط طبقات دستی انتخاب شوند
        if (parameter2?.type) {

            // ریست کردن مقدار جستجو
            if (document.querySelector('#pageMap #formMapSearch .react-select__clear-indicator')) {
                setFormMapSearchClear(true)
                setFormMapSearchClear(false)
            }

            // بستن setOffcanvasMapShow
            if (offcanvasMapShow) document.querySelector('#offcanvasMap [aria-label="Close"]').click();

        }

        // درج اطلاعات فیلتر روی نقشه
        let timeout = setTimeout(() => {

            let shopsTemp = dataTemp.shops.filter(item => item.floor === dataTemp.floors[floor - 1].label)

            shopsTemp.forEach((item, index) => {

                if (document.querySelector(`#pageMap #map svg path#path${item.value}`)) {

                    let tempPath = document.querySelector(`#pageMap #map svg path#path${item.value}`)

                    tempPath.dataset.category = `filter${item.type}`

                    if (item.logo) handlePathLogo(tempPath, item);
                    else handlePathTitle(tempPath, item);


                }

                if (index + 1 === shopsTemp.length) clearTimeout(timeout)

            })

        }, 0)

        if (refPrismaZoom.current?.getZoom() > 1 && floorCurrent.svg) refPrismaZoom.current.reset()

    }, [data, filters, offcanvasMapShow])

    useEffect(() => {

        // بار اول و زمان تغییر عرض صفحه تابع فراخوانی نشود
        if (floorCurrent.value && formState.inputs.formMapFloor.value && formState.inputs.formMapFloor.value !== '' && !formState.inputs.formMapFloor.value.value) {

            let valueTemp = formState.inputs.formMapFloor.value

            if (valueTemp.value) valueTemp = valueTemp.value

            // مقدار simulation ارسال شد تا event تشخیص داده شود
            setFloorHandler(valueTemp, {type: 'simulation'})

        }

    }, [formState.inputs.formMapFloor.value])

    // ------------------------------------------------------------------------------------------------------------ zoom

    const zoomIn = () => {
        refPrismaZoom.current.zoomIn(1)
    }

    const zoomOut = () => {
        refPrismaZoom.current.zoomOut(1)
    }

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <>
            <div id="pageMap" className="flex-grow-1 position-relative overflow-hidden">
                {
                    data ? (
                        <>
                            {
                                floorCurrent.svg ? (
                                    <PrismaZoom className="h-100 d-flex justify-content-center prisma-zoom" ref={refPrismaZoom} allowTouchEvents>
                                        <div className="position-relative h-100">
                                            <ImgMapBg className="position-absolute top-50 start-50 z-index-0 text-white text-opacity-18 map-bg"/>
                                            <div id="map" className="d-flex align-items-center h-100 position-relative z-index-1" dangerouslySetInnerHTML={{__html: floorCurrent.svg}} onClick={offcanvasMapShowHandler}/>
                                        </div>
                                    </PrismaZoom>
                                ) : (
                                    <div className="h-100 d-flex flex-column justify-content-center align-items-center text-danger"><IconFi.FiAlertTriangle size={48} className="sw-1 mb-3"/><span className="fs-5">اطلاعات نقشه دریافت نشد</span></div>
                                )
                            }
                            <div id="search" className="position-absolute top-0 start-0 end-0">
                                <Container fluid="lg" className="d-flex flex-column justify-content-center">
                                    {
                                        data ? (
                                            <FormElement component="SELECT" id="formMapSearch" name="search" options={data.shops} onInput={inputHandler} searchable searchIcon clearable clear={formMapSearchClear} placeholder="جستجوی میکا مال" className="border-0"/>
                                        ) : (
                                            <div className="text-center h5 mb-0">نقشه</div>
                                        )
                                    }
                                </Container>
                            </div>
                            <div className="position-absolute start-0 end-0">
                                <Container fluid="lg" className="d-flex h-0">
                                    <div id="zoom" className="d-flex flex-column bg-elevate-2">
                                        <Button variant="link" className="text-reset btn-icon" onClick={() => zoomIn()}><IconFi.FiPlus size={24} className="sw-1"/></Button>
                                        <hr className="my-0"/>
                                        <Button variant="link" className="text-reset btn-icon" onClick={() => zoomOut()}><IconFi.FiMinus size={24} className="sw-1"/></Button>
                                    </div>
                                </Container>
                            </div>
                            <div id="filter" className="position-absolute start-0 end-0">
                                <Container fluid="lg">
                                    {/*<div className="bg-elevate-2 py-2 overflow-hidden position-relative">*/}
                                    <div className="bg-elevate-2 py-2 position-relative">
                                        <Row className="gx-2 flex-nowrap mx-0 overflow-auto">
                                            <Col id="floor" xs="auto" className="px-0 position-absolute">
                                                <FormElement component="SELECT" id="formMapFloor" name="floor" options={data.floors} getOptionLabel={item => item.shortTitle}
                                                             editValue={data.floors.find(({value}) => value === floorCurrent.value)?.value} onInput={inputHandler} placeholder="طبقه" className="fw-bold font-en fs-18px"/>
                                            </Col>
                                            {
                                                filters.map(item => {
                                                    return (
                                                        <Col xs className="flex-shrink-0 d-grid filter" key={item.id}>
                                                            <Button type="button" variant={item.active ? 'accent' : 'link'} className={`text-decoration-none text-nowrap px-2${item.active ? '' : ' text-reset'}`} onClick={() => setFilterHandler(item.value)}>{item.title}</Button>
                                                        </Col>
                                                    )
                                                })
                                            }
                                        </Row>
                                    </div>
                                </Container>
                            </div>
                        </>
                    ) : (
                        <Container fluid="lg">
                            <Row>
                                <Col xs={12} className="py-5 my-5">
                                    <Loader text="در حال دریافت اطلاعات"/>
                                </Col>
                            </Row>
                        </Container>
                    )
                }
            </div>
            <OffcanvasMap show={offcanvasMapShow} onHide={() => offcanvasMapHideHandler()} data={offcanvasData}/>
        </>
    )
}

export default Map;